import { Component } from "react";
import "./Paypaypal.css";

export class Paypaypal extends Component {
  constructor() {
    super();
    this.state = {
      planPick: 1,
      usersData: localStorage.getItem("user_data")
        ? JSON.parse(localStorage.getItem("user_data"))
        : {},
    };
  }

  componentDidMount() {
	var mainThis = this;
	if ( this.state.usersData && this.state.usersData.id )
		{
			window.paypal.Buttons({
				style: {shape: 'pill', color: 'blue', layout: 'vertical', label: 'pay'},
				createOrder: function(data, actions) {
				  return actions.order.create({
					purchase_units: [{"description":"Mjesecno placanje "+mainThis.state.usersData.name,"amount":{"currency_code":"EUR","value":10.24},custom_id: mainThis.state.usersData.id}]
				  });
				},

				onApprove: function(data, actions) {
				  return actions.order.capture().then(function(orderData) {
					console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
					const element = document.getElementById('paypal-button-container');
					element.innerHTML = '<h3>Uplata zaprimljena. Uskoro će biti proknjižena na Vaš nalog.</h3>';
				  });
				},

				onError: function(err) {
				  console.log(err);
				}
			  }).render('#paypal-button-container');
			  
			  window.paypal.Buttons({
				style: {shape: 'pill', color: 'blue', layout: 'vertical', label: 'pay'},
				createOrder: function(data, actions) {
				  return actions.order.create({
					purchase_units: [{"description":"Godisnje placanje "+mainThis.state.usersData.name,"amount":{"currency_code":"EUR","value": 128.00},custom_id: mainThis.state.usersData.id}]
				  });
				},

				onApprove: function(data, actions) {
				  return actions.order.capture().then(function(orderData) {
					console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
					const element = document.getElementById('paypal-button-container2');
					element.innerHTML = '<h3>Uplata zaprimljena. Uskoro će biti proknjižena na Vaš nalog.</h3>';
				  });
				},

				onError: function(err) {
				  console.log(err);
				}
			  }).render('#paypal-button-container2');
		}
  }

  doClosePop = () => {
    document.querySelector(".payform-info-popup-paypal").classList.remove("active");
  };

  render() {
    return (
      <div className="payform-info-popup payform-info-popup-paypal">
        <div className="pfp_window">
          <div
            className="pfp_close"
            onClick={() => {
              this.doClosePop();
            }}
          >
            &times;
          </div>
          <div className="pfp_title">Uplata preko Bankovne kartice ili preko Paypal naloga</div>
          <div className="pfp_text">
            Izaberite opciju koju želite da platite:
          </div>

          <div className="payments_price_sections">
            <div
              className={
                "pay_price_one " +
                (this.state.planPick == 1 ? "activeprice" : "")
              }
              onClick={() => {
                this.setState({ planPick: 1 });
              }}
            >
              <div className="pay_topprice">
                <div>
					57 <span>KM</span>
				  </div>
				  20 <span>KM</span>
              </div>
              <div className="pay_toppricesub">mjesečno</div>
            </div>

            <div
              className={
                "pay_price_one " +
                (this.state.planPick == 2 ? "activeprice" : "")
              }
              onClick={() => {
                this.setState({ planPick: 2 });
              }}
            >
              <div className="pay_topprice">
                <div>
                  684 <span>KM</span>
                </div>
                250 <span>KM</span>
              </div>
              <div className="pay_toppricesub">godišnje</div>
            </div>
          </div>
		  <br /><br />
		  
		  <div className="pay_full_size">
			  <div id="paypal_mjesec" style={{"display": (this.state.planPick == 1 ? "block" : "none")}}>
				<div id="smart-button-container"><div><div id="paypal-button-container"></div></div></div>
			  </div>
			  
			  <div id="paypal_godina" style={{"display": (this.state.planPick == 2 ? "block" : "none")}}>
				<div id="smart-button-container2"><div><div id="paypal-button-container2"></div></div></div>
			  </div>
          </div>
        </div>
      </div>
    );
  }
}
